import { createAction, props } from '@ngrx/store';
import { withGenesysCloudStoreNameSpace } from '../../common/action-namespace';
import { Contact } from '../models/contact.model';

const withNameSpace = withGenesysCloudStoreNameSpace('ExternalContacts');

export const loadContact = createAction(
  withNameSpace('Load contact'),
  props<{ contactId: string }>()
);

export const contactLoaded = createAction(
  withNameSpace('Contact loaded'),
  props<{ contact: Contact }>()
);

export const contactLoadFailed = createAction(
  withNameSpace('Contact load failed')
);

export const updateContact = createAction(
  withNameSpace('Update contact'),
  props<{ contactId: string }>()
);

export const contactUpdated = createAction(
  withNameSpace('Contact updated'),
  props<{ contact: Contact }>()
);

export const subscribeToExternalContactNotifications = createAction(
  withNameSpace('Subscribe to external contact notifications'),
  props<{ contactId: string }>()
);
